module.exports = __webpack_public_path__ + "static/media/advantage1.f4e415a0.png";